module.exports = __webpack_public_path__ + "img/logo.3c7ee8aa.svg";